export default __webpack_public_path__ + "bd90450549d78c04c07b2c0595376b24.png";